var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"table table-hover",attrs:{"id":_vm.id,"width":"100%"}},[_c('thead'),_vm._v(" "),_c('tbody')])])
}
var staticRenderFns = []

export { render, staticRenderFns }